import { useDispatch, useSelector } from "react-redux";

import { setProductValue } from "../../../actions/productCreateAction";
import { constants } from '../../../Constants/constants';
import { GetProductBrandCode } from "../../Brand/GetProductBrandCode";

import { maybeClearDependentFields } from "./clearDependentFields";

export const ProductBrandCode = ({ disableInput, helperTextStylesClasses }) => {
  const dispatch = useDispatch();
  const savedProduct = useSelector(state => state.product.ui.product)

  function handleBrandCode(brandCode) {
    dispatch(setProductValue(constants.ACTION_KEY.PRODUCT.PRODUCT, savedProduct, "brandCode",
      {
        brandCode: brandCode.brandCode,
        brandTcName: brandCode.tcName
      }));

    try {
        // left image change can affect generated cash coupon images
        maybeClearDependentFields(dispatch, savedProduct, "brandCode")
    } catch (err) {
        // ignore
    }
  }

  function handleClearBrandCode() {
    dispatch(setProductValue(constants.ACTION_KEY.PRODUCT.PRODUCT, savedProduct, "brandCode",
      {
        brandCode: "",
        brandTcName: "",
      }));

    try {
        // left image change can affect generated cash coupon images
        maybeClearDependentFields(dispatch, savedProduct, "brandCode")
    } catch (err) {
        // ignore
    }
  }

  return (
    <>
      <GetProductBrandCode disableInput={disableInput} savedData={savedProduct.draft.product} sendBrandCode={handleBrandCode} clearBrandCode={handleClearBrandCode}/>
    </>
  )
};